import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import {useEvent} from 'Event/EventProvider'
import ErrorAlert from 'lib/ui/alerts/ErrorAlert'
import Select from 'lib/ui/Select'
import TextField from 'lib/ui/TextField'
import Option from 'lib/ui/Select/Option'
import {getEventUrl} from 'lib/url'
import Page from 'organization/Event/Page'
import {UserRegistrationMode} from 'organization/Event/Services/Apps/Obie'
import AttendeeLinks from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks'
import CopyLinkButton from 'organization/Event/Services/Apps/Obie/Config/CopyLinkButton'
import DisconnectButton from 'organization/Event/Services/Apps/Obie/Config/DisconnectButton'
import HubSelect from 'organization/Event/Services/Apps/Obie/Config/HubSelect'
import ModeDescription from 'organization/Event/Services/Apps/Obie/Config/ModeDescription'
import OfferSelect from 'organization/Event/Services/Apps/Obie/Config/OfferSelect'
import {useSave} from 'organization/Event/Services/Apps/Obie/Config/use-save'
import {useObie} from 'organization/Event/Services/ServicesProvider'
import React, {useState} from 'react'
import {ServicesBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'

export default function Config() {
  const obie = useObie()
  const {event} = useEvent()
  const attendeeUrl = `${getEventUrl(event)}/obie`
  const [hubId, setHubId] = useState(obie.obie_hub_id)
  const [offerId, setOfferId] = useState(obie.obie_offer_id)
  const [mode, setMode] = useState(obie.user_registration_mode)
  const {save, isSaving, error} = useSave()

  const isSignUp = mode === 'sign_up'
  const canSave = Boolean(hubId) && (!isSignUp || Boolean(offerId))

  const handleSave = (submit: React.FormEvent) => {
    submit.preventDefault()

    if (!hubId) {
      return
    }

    save({
      obie_hub_id: hubId,
      user_registration_mode: mode,
      obie_offer_id: isSignUp ? offerId : null,
    })
  }

  return (
    <ServicesBreadcrumbs page="Obie">
      <Page>
        <>
          <Box mb={3}>
            <Grid container spacing={2} alignItems="center">
              <Grid item md={6}>
                <Typography variant="h4">Obie</Typography>
              </Grid>
              <Grid item md={6}>
                <Box display="flex" justifyContent="flex-end">
                  <DisconnectButton />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <TextField
            label="Attendee link"
            variant="outlined"
            value={attendeeUrl}
            inputProps={{'aria-label': 'attendee link'}}
            disabled
            fullWidth
            endAdornment={<CopyLinkButton url={attendeeUrl} />}
          />

          {obie.obie_hub_id && <AttendeeLinks obieHubId={obie.obie_hub_id} />}

          <form onSubmit={handleSave}>
            <HubSelect value={hubId} onChange={setHubId} disabled={isSaving} />

            <Select
              label="Attendee Registration"
              aria-label="attendee registration"
              value={mode}
              onChange={(event) =>
                setMode(event.target.value as UserRegistrationMode)
              }
              disabled={isSaving}
              fullWidth
            >
              <Option value="auto">Auto</Option>
              <Option value="sign_up">Sign Up</Option>
              <Option value="disabled">Disabled</Option>
            </Select>

            <ModeDescription mode={mode} />

            {isSignUp && hubId && (
              <OfferSelect
                obieHubId={hubId}
                value={offerId}
                onChange={setOfferId}
                disabled={isSaving}
              />
            )}

            <ErrorAlert>{error}</ErrorAlert>

            <Box mb={5}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                aria-label="save"
                disabled={isSaving || !canSave}
              >
                Save
              </Button>
            </Box>
          </form>
        </>
      </Page>
    </ServicesBreadcrumbs>
  )
}
